import { render } from "./UserRolesPage.vue?vue&type=template&id=1ef32524&scoped=true"
import script from "./UserRolesPage.vue?vue&type=script&lang=js"
export * from "./UserRolesPage.vue?vue&type=script&lang=js"

import "./UserRolesPage.vue?vue&type=style&index=0&id=1ef32524&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef32524"]])

export default __exports__